// recipients-filter-chips.tsx
// The chips that filter a list of recipients (files to correct, unreachable, without address...) with what each one means on hover.
// Shared by the step of the participants and by the import step.
import { useTranslation } from "react-i18next"
import Chip from "@/components/chip"
import Tooltip from "@/components/tooltip"
import { RECIPIENTS_FILTERS, RecipientsFilter } from "@/features/survey/entities/recipients-view/recipients-view.store"

interface OwnProps {
  counts: { [filter: string]: number }
  current: RecipientsFilter
  onSelect: (filter: RecipientsFilter) => void
}

//Colours of the charter (variables of style/index.css) : the filters are problems to look at, like the warnings of the step (orange) ; "all" is neutral
const COLOR_ALL = "var(--idt-grey)"
const COLOR_PROBLEM = "var(--idt-orange)"

export default function RecipientsFilterChips(props: OwnProps) {
  const { t } = useTranslation()

  //Only the filters that have files to show, and the active one whatever its number
  const filters = RECIPIENTS_FILTERS.filter((filter) => props.counts[filter] > 0 || props.current === filter)
  if (filters.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-2" style={{ margin: "12px 0", padding: "0 32px" }}>
      <Chip color={COLOR_ALL} isOutlineColored={props.current !== ""} onClick={() => props.onSelect("")}>
        {t("project_recipients_filter_all")}
      </Chip>
      {filters.map((filter) => (
        <Tooltip key={filter} text={t("project_recipients_filter_" + filter + "_help")} position="top" usePortal>
          <Chip
            color={COLOR_PROBLEM}
            count={props.counts[filter] || 0}
            isOutlineColored={props.current !== filter}
            onClick={() => props.onSelect(filter)}>
            {t("project_recipients_filter_" + filter)}
          </Chip>
        </Tooltip>
      ))}
    </div>
  )
}
